import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = ({ page, limit, total, onPageChange }) => {
	const totalPages = Math.max(1, Math.ceil(total / limit));
	const start = total === 0 ? 0 : (page - 1) * limit + 1;
	const end = Math.min(page * limit, total);

	const canPrev = page > 1;
	const canNext = page < totalPages;

	return (
		<div className="flex items-center justify-between px-6 py-4 bg-slate-900/50 border-t border-slate-700">
			<p className="text-sm text-slate-400">
				{total === 0 ? (
					"Nenhum registro encontrado"
				) : (
					<>
						Mostrando{" "}
						<span className="font-medium text-slate-200">{start}</span>
						{"-"}
						<span className="font-medium text-slate-200">{end}</span>
						{" de "}
						<span className="font-medium text-slate-200">{total}</span>
					</>
				)}
			</p>

			<div className="flex items-center gap-2">
				<button
					type="button"
					onClick={() => onPageChange(page - 1)}
					disabled={!canPrev}
					className="inline-flex items-center gap-1 px-3 py-1.5 text-sm font-medium rounded-lg border border-slate-700 bg-slate-800/50 text-slate-300 transition-all hover:bg-slate-700 hover:border-cyan-500/30 hover:text-cyan-300 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-slate-800/50 disabled:hover:border-slate-700 disabled:hover:text-slate-300 active:scale-95"
				>
					<ChevronLeft className="w-4 h-4" />
					Anterior
				</button>

				<span className="px-3 py-1.5 text-sm text-slate-400">
					<span className="font-medium text-cyan-400">{page}</span>
					{" / "}
					{totalPages}
				</span>

				<button
					type="button"
					onClick={() => onPageChange(page + 1)}
					disabled={!canNext}
					className="inline-flex items-center gap-1 px-3 py-1.5 text-sm font-medium rounded-lg border border-slate-700 bg-slate-800/50 text-slate-300 transition-all hover:bg-slate-700 hover:border-cyan-500/30 hover:text-cyan-300 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-slate-800/50 disabled:hover:border-slate-700 disabled:hover:text-slate-300 active:scale-95"
				>
					Proximo
					<ChevronRight className="w-4 h-4" />
				</button>
			</div>
		</div>
	);
};

export default Pagination;
